var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mb-20 px-4", attrs: { flat: "" } },
    [
      _c("data-table-title", {
        attrs: {
          icon: "bookmark",
          title: "Pedidos",
          "button-text": "Criar novo pedido",
          "button-route": { name: "new-order" },
          search: _vm.search
        },
        on: {
          search: function($event) {
            return _vm.submitSearch($event)
          }
        }
      }),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.items,
              options: _vm.options,
              "server-items-length": _vm.totalItems,
              "footer-props": _vm.footerProps,
              loading: _vm.loader
            },
            on: {
              "update:options": function($event) {
                _vm.options = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "item.status",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "router-link",
                      { attrs: { to: _vm.orderLink(item.id) } },
                      [
                        _c("icon-tooltip", {
                          attrs: { options: _vm.getStatus(item.status) }
                        })
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "item.link",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "clipboard",
                            rawName: "v-clipboard:copy",
                            value: _vm.copyLink(item),
                            expression: "copyLink(item)",
                            arg: "copy"
                          },
                          {
                            name: "clipboard",
                            rawName: "v-clipboard:success",
                            value: _vm.copied,
                            expression: "copied",
                            arg: "success"
                          }
                        ],
                        staticClass: "pointer"
                      },
                      [
                        _c("icon-tooltip", {
                          attrs: { options: _vm.copyOptions }
                        })
                      ],
                      1
                    )
                  ]
                }
              },
              {
                key: "item.type",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("icon-tooltip", {
                      attrs: {
                        options: item.cycle
                          ? _vm.cycleOptions
                          : _vm.orderOptions
                      }
                    })
                  ]
                }
              },
              {
                key: "item.created_at",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("v-chip", { attrs: { small: "", outlined: "" } }, [
                      _vm._v(_vm._s(_vm._f("dateAndTime")(item.created_at)))
                    ])
                  ]
                }
              },
              {
                key: "item.customer",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("profile-row", {
                      attrs: { account: item.customer.account }
                    })
                  ]
                }
              },
              {
                key: "item.professional",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("profile-row", {
                      attrs: { account: item.professional.account }
                    })
                  ]
                }
              },
              {
                key: "item.starts_at",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("v-chip", { attrs: { small: "", outlined: "" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateAndTime")(item.schedule_event.starts_at)
                        )
                      )
                    ])
                  ]
                }
              },
              {
                key: "item.duration",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("v-chip", { attrs: { small: "", outlined: "" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("secondsToHours")(item.schedule_event.duration)
                        )
                      )
                    ])
                  ]
                }
              },
              {
                key: "item.city",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("v-chip", { attrs: { small: "", color: "primary" } }, [
                      _vm._v(_vm._s(_vm._f("cityAndState")(item.address)))
                    ])
                  ]
                }
              },
              {
                key: "item.price",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("v-chip", { attrs: { small: "" } }, [
                      _vm._v(_vm._s(_vm._f("intToCurrency")(item.amount.price)))
                    ])
                  ]
                }
              },
              {
                key: "item.fee",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("v-chip", { attrs: { small: "", color: "accent" } }, [
                      _vm._v(_vm._s(_vm._f("intToCurrency")(item.amount.fee)))
                    ])
                  ]
                }
              },
              {
                key: "item.total",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("v-chip", { attrs: { small: "" } }, [
                      _vm._v(_vm._s(_vm._f("intToCurrency")(item.amount.total)))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48e043a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48e043a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Orders/List.vue
// module id = null
// module chunks = 